export const FAQ_SECTIONS = [
  {
    id: "placement",
    title: "Placement & Career",
    icon: "BriefcaseBusiness",
    items: [
      { q: "Do you provide guaranteed job placement?", a: "We do not guarantee placement, but we do guarantee to schedule interviews for you. Final placement depends on your interview performance." },
      { q: "Have you provided placements in the past?", a: "Yes. We have successfully placed 100+ students." },
      { q: "Do you have genuine hiring partners?", a: "Yes. We have hiring partners across Delhi and Noida." },
      { q: "Do you provide interview guidance?", a: "Yes, we do." },
    ],
  },
  {
    id: "certification",
    title: "Certification & Recognition",
    icon: "Award",
    items: [
      { q: "Do you provide a certificate after course completion?", a: "Yes. Every student receives a certificate on successful completion of the course." },
      { q: "Do you have government registration?", a: "Yes. The institute is government registered." },
    ],
  },
  {
    id: "learning",
    title: "Learning & Practice",
    icon: "BookOpenCheck",
    items: [
      { q: "Do you provide practical or theoretical knowledge?", a: "We provide 100% practical learning." },
      { q: "Do you provide data for practice?", a: "Yes. Practice data is provided to every student." },
      { q: "Do students have Wi-Fi access?", a: "Yes. Students have Wi-Fi access at the institute." },
      { q: "Can students practice after course completion?", a: "Yes. We provide lifetime free practice to all our students." },
      { q: "Do you provide study material or notes?", a: "Yes. Study material and notes are provided." },
      { q: "Is the course curriculum updated regularly?", a: "Yes. Our curriculum is updated regularly." },
      { q: "In which language are classes conducted?", a: "Classes are conducted in both Hindi and English — mainly Hinglish — and adjusted according to each student's comfort." },
    ],
  },
  {
    id: "fees",
    title: "Fees & Payment",
    icon: "IndianRupee",
    items: [
      { q: "Do you offer instalment or EMI payment?", a: "Yes. Fees are collected monthly, in advance." },
      { q: "Are there any hidden charges?", a: "No hidden charges. Apart from the monthly course fee, there is a one-time registration charge payable at the time of admission (along with the first monthly fee), and an exam fee payable at the time of the examination." },
    ],
  },
  {
    id: "timing",
    title: "Timing & Flexibility",
    icon: "Clock3",
    items: [
      { q: "What are your batch timings?", a: "Batches run from 8 AM to 8 PM. Each student attends a one-hour slot, with morning, afternoon and evening slots available. Lunch break is from 1 PM to 2 PM." },
      { q: "Do you offer weekend or evening batches for working students?", a: "Yes. Weekend and evening batches are available for working students." },
      { q: "Can I join mid-month?", a: "Yes. You can join at any time — we provide individual attention to every student in each batch." },
    ],
  },
  {
    id: "courses",
    title: "Course Details",
    icon: "Layers",
    items: [
      { q: "How long are your courses?", a: "Course durations available: 30 days, 45 days, 90 days, 6 months, 12 months, 18 months and 24 months." },
      { q: "How many students are in one batch?", a: "A maximum of 8 students per batch, to ensure quality education and individual attention." },
      { q: "Can I switch courses after enrolment?", a: "Yes. Please contact our office admin staff for assistance." },
    ],
  },
  {
    id: "higher-education",
    title: "Higher Education",
    icon: "GraduationCap",
    items: [
      { q: "Do you provide higher education consultation?", a: "Yes. We provide higher education consultation." },
      { q: "Do you help complete 10th and 12th through Open Schooling?", a: "Yes. We help students complete their 10th and 12th through Open Schooling." },
      { q: "Do you provide admissions to graduation and post-graduation courses through online or distance mode?", a: "Yes. We are partnered with Mangalayatan University and Subharti University." },
    ],
  },
  {
    id: "institute",
    title: "About the Institute",
    icon: "Building2",
    items: [
      { q: "How long has the institute been running?", a: "The institute has been running since 2022." },
      { q: "Is the institute easily accessible by metro or bus?", a: "Yes. Nearest metro stations: Saket, Nehru Enclave, Govind Puri and Badarpur Border. Nearest bus stop: Hamdard Nagar Bus Station." },
      { q: "Is the environment safe for female students?", a: "Yes. We are located on the ground floor in a calm and clean area, and Lord Krishna Public School is situated right in front of our institute." },
    ],
  },
];
